<script>
import CentralHeader from "../components/shared/CentralHeader.vue";

export default {
  name: "PastEvents",
  components: { CentralHeader }
};
</script>

<template>
  <div class="max-w-7xl mx-auto sm:px-2 lg:px-8 mb-12">
    <CentralHeader title="Past Events">Past Events </CentralHeader>
    <div class="grid md:grid-cols-2 justify-items-center place-content-center gap-10 mt-12">
      <div class="border-4 border-white col-span-2 lg:col-span-1">
        <a href="https://ugm-2020.vectric.com/" target="_blank">
          <img src="/images/WWUGM_2020.jpg" />
        </a>
      </div>
      <div class="border-4 border-white col-span-2 lg:col-span-1">
        <a href="https://ugm-2021.vectric.com/" target="_blank">
          <img src="/images/WWUGM_2021.jpg" />
        </a>
      </div>
      <div class="border-4 border-white col-span-2 lg:col-span-1">
        <a href="https://ugm-2023.vectric.com/" target="_blank">
          <img src="/images/WWUGM_2023.png" />
        </a>
      </div>
      <div class="border-4 border-white col-span-2 lg:col-span-1">
        <a href="https://ugm-2024.vectric.com/" target="_blank">
          <img src="/images/WWUGM_2024.png" />
        </a>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
